module.exports = __webpack_public_path__ + "static/media/facebook-circle-button.f2126232.svg";